import history from '../history';
import { AUTH_CLEAR } from '../store/auth/actionsTypes';
import { CLEAR_DASHBOARD } from '../store/dashboard/actionsTypes';
import { CLEAR_USER } from '../store/usuario/actionsTypes';
import { saveAuthReturnUrl } from './returnUrl';

let isHandlingSessionExpired = false;

const isPublicAuthRequest = (requestUrl = '') => {
  const normalized = requestUrl.toLowerCase();
  return normalized.includes('/login') || normalized.includes('forgot-password');
};

const clearAuthState = async () => {
  const { state } = await import('../store');
  state.dispatch({ type: AUTH_CLEAR });
  state.dispatch({ type: CLEAR_DASHBOARD });
  state.dispatch({ type: CLEAR_USER });
};

export const handleSessionExpired = (requestUrl = '') => {
  if (isHandlingSessionExpired || isPublicAuthRequest(requestUrl)) {
    return;
  }

  const { pathname, search } = window.location;

  if (!pathname.startsWith('/v2') || pathname === '/v2/login') {
    return;
  }

  isHandlingSessionExpired = true;

  saveAuthReturnUrl(`${pathname}${search}`);

  clearAuthState();

  history.replace('/v2/login');

  window.setTimeout(() => {
    isHandlingSessionExpired = false;
  }, 1000);
};
